{
  "name": "jbrowse-plugin-gdc",
  "version": "2.3.4",
  "description": "JBrowse 2 GDC plugin",
  "keywords": [
    "jbrowse",
    "jbrowse2",
    "GDC"
  ],
  "license": "MIT",
  "homepage": "https://github.com/GMOD/jbrowse-plugin-gdc#readme",
  "bugs": "https://github.com/GMOD/jbrowse-plugin-gdc/issues",
  "repository": "github:GMOD/jbrowse-plugin-gdc",
  "author": "Andrew Duncan",
  "main": "dist/index.js",
  "module": "dist/index.esm.js",
  "typings": "dist/index.d.ts",
  "files": [
    "dist",
    "src"
  ],
  "jbrowse-plugin": {
    "name": "GDC"
  },
  "scripts": {
    "proxy": "lcp --proxyUrl https://api.gdc.cancer.gov",
    "clean": "rimraf dist",
    "format": "prettier --write .",
    "prebuild": "pnpm clean",
    "start": "node esbuild.mjs --watch",
    "build": "tsc && NODE_ENV=production node esbuild.mjs",
    "build:bundle": "NODE_ENV=production node esbuild.mjs",
    "postbuild": "cp distconfig.json dist/config.json",
    "lint": "eslint --report-unused-disable-directives --max-warnings 0",
    "test": "vitest run",
    "prepack": "pnpm build",
    "postversion": "git push --follow-tags"
  },
  "dependencies": {
    "@mui/icons-material": "^7.0.0",
    "abortable-promise-cache": "^1.5.0",
    "pako": "^2.1.0",
    "react-dropzone": "^15.0.0",
    "uuid": "^14.0.0"
  },
  "peerDependencies": {
    "@jbrowse/core": "^4.0.0"
  },
  "devDependencies": {
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@eslint/js": "^10.0.1",
    "@fal-works/esbuild-plugin-global-externals": "^2.1.2",
    "@gmod/bgzf-filehandle": "^6.0.19",
    "@jbrowse/cli": "^4.2.1",
    "@jbrowse/core": "^4.2.0",
    "@jbrowse/mobx-state-tree": "^5.6.0",
    "@jbrowse/plugin-linear-genome-view": "^4.2.0",
    "@mui/material": "^7.0.0",
    "@mui/x-data-grid": "^9.0.4",
    "@schemastore/package": "^1.0.4",
    "@testing-library/react": "^16.3.2",
    "@types/node": "^25.6.0",
    "@types/pako": "^2.0.4",
    "@types/react": "^19.2.14",
    "@types/uuid": "^11.0.0",
    "esbuild": "^0.28.0",
    "eslint": "^10.2.1",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-unicorn": "^64.0.0",
    "jsdom": "^29.0.2",
    "local-cors-proxy": "^1.1.0",
    "mobx": "^6.15.0",
    "mobx-react": "^9.2.1",
    "mobx-state-tree": "7.2.0",
    "prettier": "^3.8.3",
    "pretty-bytes": "^7.1.0",
    "react": "^19.2.5",
    "react-dom": "^19.2.5",
    "rimraf": "^6.1.3",
    "rxjs": "^7.8.2",
    "serve": "^14.2.6",
    "tss-react": "^4.9.20",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.59.1",
    "vite": "^8.0.10",
    "vitest": "^4.1.5"
  }
}
